<template>
	<div>
        <div class="w-50">
            <jodit-editor v-model="content"/>
        </div>
        <div class='w-50 report-size-input p-1'>
            <div class="card-header2 col-lg-8 col-xl-7 pd-y-15 pd-x-20 d-flex align-items-center justify-content-end"></div>
             <ul class="sidebar-nav">
                <li class="mg-b-10-f font-weight-bold">Product</li>
                <b-radio v-for="form in productForm" v-model="productPick" name="prop" :key="form.id" :native-value="form.id" @click.native="productChange(form.id)">{{form.name}}</b-radio>
            </ul>
            <ul class="sidebar-nav">
                <li class="mg-b-10-f font-weight-bold">Template</li>
                <b-radio v-for="form in templateForm" v-model="templatePick" name="temp" :key="form.id" :native-value="form.id" @click.native="makeA4(form.id)">{{form.name}}</b-radio>
            </ul>
            <ul class="sidebar-nav mg-t-10-f">
                <li class="mg-b-10-f font-weight-bold">Department</li>
                <b-radio  v-for="form in department" v-model="radioPick" name="dept" :key="form" :native-value="form" @click.native="classifyGeneralInfo(form)">{{form}}</b-radio>
            </ul>
            <ul v-if="this.sampleTypeForm.length != 0" class="sidebar-nav mg-t-10-f">
                <li class="mg-b-10-f font-weight-bold">Sample Type List</li>
                <b-radio v-for="form in sampleTypeForm" v-model="sampleTypePick" name="samt" :key="form.id" :native-value="form.id" @click.native="selectSampleType(form.id)">{{form.name}}</b-radio>
            </ul>
            <ul v-if="this.sampleTypeForm.length != 0" class="sidebar-nav mg-t-10-f">
                <li class="mg-b-10-f font-weight-bold">Sample Group</li>
                <b-radio v-for="form in sampleTypeForm" v-model="sampleGroupPick" name="samt" :key="form.id" :native-value="form.id" @click.native="sampleGroup(form.id)">{{form.name}}</b-radio>
            </ul>
            <ul class="sidebar-nav">
                <div class="form-group"> 
                    <label class="font-weight-bold d-block mg-t-10-f mg-b-10-f">Sample QC Table</label>
                    <div class="d-block mg-b-10-f">
                        <label class="nav-label d-block">Sample Name 선택</label>
                        <b-radio v-for="form in sampleNameForm" v-model="sampleNamePick" name="temp" :key="form.id" :native-value="form.id" @click.native="finalFunction(form.id)">{{form.name}}</b-radio>
                    </div>
                    <!-- <div class="display-inline-block">
                        <label class="nav-label d-block">1번 병합(가로) 개수</label>
                        <input type="text" class="form-control display-inline-block" placeholder="1번 병합(가로)" v-model="firColspan">
                    </div>
                    <div class="display-inline-block">
                        <label class="nav-label d-block">2번 병합(가로) 개수</label>
                        <input type="text" class="form-control display-inline-block" placeholder="2번 병합(가로)" v-model="secColspan">
                    </div>
                    <div class="display-inline-block mg-b-10-f">
                        <label class="nav-label d-block">3번 병합(가로) 개수</label>
                        <input type="text" class="form-control display-inline-block" placeholder="3번 병합(가로)" v-model="thrColspan">
                    </div> -->
                    <div class="custom-control custom-checkbox mg-b-7 display-inline-block" v-for="(form,i) in sampleQCResult">
                        <label class="nav-label d-block ml-m-1rem">{{form.name}}</label>
                        <div class="pos-relative-f  wd-25p-f float-left" v-for="(form1, j) in exp_d_h_info" v-if="form1.idx === Number(i)+1">
                            <input type="checkbox" class="custom-control-input" :id="form1.columnCode" :value="form1.columnCode" v-model="checkedColumn" @change="finalFunction()">
                            <label class="custom-control-label" :for="form1.columnCode">{{form1.columnName}}</label>
                        </div>
                    </div>
                    <div v-if="templatePick == 'hab'">
                        <div class="col-lg-4"><p class="d-block">Bioanalyzer HighSensitivity chip Image</p><imgUpload @imgFileHandler="this.imgFileHandler"/></div>
                        <div class="col-lg-4"><p class="d-block">DNA Ladder DyneBio Chart Image</p><imgUpload @imgFileHandler="this.imgFileHandler2"/></div>
                    </div>
                   <div v-if="templatePick == 'hab'">
                        <div class="col-lg-5"><p class="d-block">Purification Chart Image</p><imgUpload2 @imgFileHandler="this.imgFileHandler3"/></div>
                    </div>
                   <div v-if="templatePick == 'dft'">
                        <div class="col-lg-5"><p class="d-block">DNA Quantity Chart Image</p><imgUpload2 @imgFileHandler="this.imgFileHandler4"/></div>
                    </div>
                </div>
            </ul>
        </div>
    </div>

</template>
<script>
	// 공통 함수 관리 파일 임포트
    import common from "@/views/Common/common.js";
    // 리포트 텍스트 임포트
    import edt_txt from "@/views/Common/editor_txt.js";
    import imgUpload from '@/views/Common/image-upload/editorImgUpload'
    import imgUpload2 from '@/views/Common/image-upload/imgUpload'
    import moment from "moment";
    import 'jodit/build/jodit.min.css'
    import { JoditEditor } from 'jodit-vue'
    export default {
        name: 'app',
        data() {
            return {
                content: '',
                experimentHeader : this.$route.params.experimentHeader,
                experimentData : this.$route.params.experimentData,
                sampleData : this.$route.params.sampleData,
                menuData : this.$route.params.menuData,
                mid : this.$route.params.dprops.mid,
                uid : this.$route.params.dprops.uid,
                // 탬플릿 종류
                templateForm : [{id: 'oqo', name: '수주 Qubit O'},{id: 'oqx', name: '수주 Qubit X'},{id: 'nano', name: 'Nanopore'}],
                // Sample QC Result 테이블 Sample Name 선택 옵션들 
                sampleNameForm : [{id: 'id', name : 'Sample Id'}, {id: 'barcode', name : 'Barcode'}, {id: 'sampleName', name : 'Sample Name'}],
                // Sample 이 여러개 일 경우 선택
                sampleTypeForm : [{id:'stool', name: 'stool'},{id:'Tissue', name: 'Tissue'}, {id:'각다귀', name: '각다귀'}, {id:'Buccal', name: 'Buccal'}, {id:'돼지 Tissue', name: '돼지 Tissue'}, {id:'gDNA', name: 'gDNA'},{id:'Urine', name: 'Urine'},{id:'Plant', name: 'Plant'},{id:'Saliva', name: 'Saliva'},{id:'Whole Blood', name: 'Whole Blood'}  ],
                // productForm 을 사용자가 직접 선택할 수 있도록
                productForm:[{id:'Nanopore 1D Library QC', name:'Nanopore 1D Library QC'}, {id:'Nanopore 1D NBD Library QC', name:'Nanopore 1D NBD Library QC'}, {id:'Sample QC', name:'Sample QC'}, {id:'DNA Purification', name:'DNA Purification'},{id:'RNA Treatment', name:'RNA Treatment'}],
                productPick:'',
                nowdate: '',
                experimentno: '',
                department: [],
                radioPick: '',
                sample_info: [],
                sampleQCResult: [],
                idx: 0,
                exp_d_h_info: [],
                checkedColumn:[
                    "C00038",
                    "C00041",
                    "C00042",
                    "C00039",
                    "C00040"
               
                ],
                watchData:'',
                checkedColumnData: [],
                checkedColumnHeader: [],
                templatePick: '',   // 사용자 선택 템플릿
                sampleTypePick: '', // 사용자 선택 샘플 타입
                sampleNamePick: '', // 사용자 선택 샘플 이름
                sampleGroupPick: '',
                sampleSingleType:'',
                sampleState:'', // 샘플 group or single 상태 확인
                cover_txt : '',
                g_info_txt: '',
                dna_quality_txt: '',
                sampleQCResult_txt: '',
                sampleQCTableHeader_txt: '',
                sampleQCTableData_txt: '',
                imgData: [],
                lastImgData: [],
                nanoData : [],
                firColspan : 5,
                secColspan : 2,
                thrColspan : 0,
                imgFileFormData: new FormData,
                pasteForm: new FormData,
                pasteCount: 0,
                g_sampleTable: [],      
                g_sampleGroupTable:[] // group sample table
            }
        },
        created() {
            this.classifyGeneralInfo();
            this.classifyTotalHeader();
            this.sampleTypeList();
            //this.dna_quality_table_row();
        },
        components: {
            moment,
            JoditEditor,
            imgUpload,
            imgUpload2
        },
        methods: {
            async classifyTotalHeader(){
                try{
                    common.makeHeader(this.mid, this.menuData, 2)[1].forEach((a,b,c)=>{
                        if(a.gubun === 'detail'){
                            if(a.mid != c[b-1].mid) {
                                this.sampleQCResult.push(a.mid);
                                this.idx++;
                            }
                            else if(a.gubun != c[b-1].gubun){
                                this.sampleQCResult.push(a.mid);
                                this.idx++;
                            }
                            a.idx = this.idx;
                            this.exp_d_h_info.push(a);
                        }
                    });
                    this.sampleQCResult.forEach(a=>{
                        this.checkedColumnHeader.push([]);
                    });
                    this.menuData.forEach((a)=>{
                        a.subs.forEach((b)=>{
                            this.sampleQCResult.forEach((c, d)=>{
                                if(b.id === c) this.sampleQCResult.splice(d, 1, {id:c, name:b.menuName})
                            });
                        });
                    });
                    this.sampleQCTableHeader_txt = edt_txt.sampleQCTableHeader(1, 5, 2, [], []); // rowspan, first row: colspan, second row: colspan, checkedColumnHeader arr, purity arr
                }catch (error) {console.log(error)}
            },
            async classifyGeneralInfo(deptname){
                try{
                    this.sample_info.splice(0);
                    let experimentDate = this.experimentHeader.find(a=>a.columnAttr == 'experimentdate').columnCode;
                    let volumecode = common.isNull(common.menuHeader(this.mid, this.menuData, 2)[3].find(a=>a.columnAttr == 'volume'))?'':common.menuHeader(this.mid, this.menuData, 2)[3].find(a=>a.columnAttr == 'volume').columnCode;
                    let sampleheader = common.sampleHeader(this.menuData);
                    let deptcode = '';
                    this.nowdate = this.experimentData[experimentDate];
                    let changeDate = this.nowdate.split('~');
                    //실험 시작일과 종료일이 같을 경우 
                    if(changeDate[0] == changeDate[1]){
                       this.nowdate = changeDate[0];
                        console.log(changeDate[0])
                    }
                    this.nowdate = this.nowdate.replace(/~$/,'');     
                    this.sampleData.forEach((a, b)=>{
                        common.receptionHeader(this.menuData).forEach(c => {
                            if(c.columnType === 'COMPANY') {
                                this.department.push(a[c.columnCode]);
                                deptcode = c.columnCode;
                            }
                        });
                    });
                    this.department = Array.from(new Set(this.department));
                    if(this.department.length == 1) this.radioPick = this.department[0];
                    this.experimentHeader.forEach(a=>{
                        if(a.columnAttr === 'experimentno'){
                            this.experimentno = this.experimentData[a.columnCode];
                        }
                    });
                    if(!common.isNull(deptname)){
                        let rn = Number(0);
                        this.sampleData.forEach((a, b)=>{
                            if(deptname == a[deptcode]){
                                this.sample_info.push({'no':Number(rn)+1});
                                sampleheader.forEach(c => {
                                    if(c.columnAttr === 'sampleid') this.sample_info[rn].sampleid = common.isNull(a[c.columnCode]) ? '' : a[c.columnCode];
                                    if(c.columnAttr === 'sampletype') this.sample_info[rn].sampletype = common.isNull(a[c.columnCode]) ? '' : a[c.columnCode];
                                    if(c.columnAttr === 'product') this.sample_info[rn].product = common.isNull(a[c.columnCode]) ? '' : a[c.columnCode];
                                });
                                this.sample_info[rn].volume = common.isNull(a[volumecode]) ? '' : a[volumecode];
                                this.experimentHeader.forEach(c => {
                                    if(c.columnAttr === 'createdate') this.sample_info[rn].createdate = common.isNull(this.experimentData[c.columnCode]) ? '' : this.experimentData[c.columnCode];
                                    if(c.columnAttr === 'updatedate') this.sample_info[rn].updatedate = common.isNull(this.experimentData[c.columnCode]) ? '' : this.experimentData[c.columnCode];
                                });
                                this.sample_info[rn].experimentdate = common.isNull(this.nowdate) ? '' : this.nowdate.substr(0,this.nowdate.indexOf('~'))+'<br/>'+this.nowdate.substr(this.nowdate.indexOf('~'), this.nowdate.length);
                                rn++
                            }
                        });
                        this.makeA4(this.templatePick);
                    }
                }catch (error) {console.log(error)}
            },
            async productChange(propick){
                //console.log(propick)
            },

            async sampleGroup(sampt){
                try {
                    //group 일 경우
                    /*

                    여러개인 샘플들을 General Information에서 하나로 그룹지어 표시 함수 

                    */
                    this.sampleState = 'group';

                    this.g_sampleGroupTable = [];
                    let requester='';
                    let consignee='';
                    let repno='';
                    let deliverydate='';
                    let json = '';
                    let sampleName = '';
                    let sampleType = '';
                    let volume = '';
                    let experimentDate = '';
                    let product = '';
                    let sampleheader = common.sampleHeader(this.menuData);

                    //sample data 구분 위한 코드 호출
                    let sampleNameCode = sampleheader.find(a=>a.columnAttr == 'samplename').columnCode;
                    let sampletypeCode = sampleheader.find(a=>a.columnAttr == 'sampletype').columnCode;
                    let productCode = sampleheader.find(a=>a.columnAttr == 'product').columnCode;
                    let volumnCode = this.exp_d_h_info.find(a=>a.columnAttr == 'volume').columnCode;
                    let rn = Number(0);
                        this.sampleData.forEach((a, b)=>{
                            this.sample_info.push({'no':Number(rn)+1});
                            experimentDate = this.sample_info[rn].experimentdate = common.isNull(this.nowdate) ? '' : this.nowdate;
                            rn++
                    });
                    requester = this.sampleData[0]['C00408'];//의뢰자
                    consignee = this.sampleData[0]['C00409'];//인수자
                    deliverydate = this.sampleData[0]['C00410'];//입고일
                    repno = this.sampleData[0]['C00411'];//수주번호
                    requester = common.isNull(requester)?'-':requester;
                    consignee = common.isNull(consignee)?'-':consignee;
                    deliverydate = common.isNull(deliverydate)?'-':deliverydate;
                    repno = common.isNull(repno)?'-':repno;
                    sampt = common.isNull(sampt)?'-':sampt;//선택샘플
                    this.sampleData.forEach((a,b) => {
                      if(a[sampletypeCode] == sampt){
                            sampleName = common.isNull(a[sampleNameCode])?'-':a[sampleNameCode];
                            sampleType = common.isNull(a[sampletypeCode])?'-':a[sampletypeCode];
                            volume = common.isNull(a[volumnCode])?'-':a[volumnCode];
                            experimentDate = common.isNull(experimentDate)?'-':experimentDate;
                            product = common.isNull(a[productCode])?'-':a[productCode];
                            json = {
                                    "sampleName": sampleName,
                                    "sampleType": sampleType,
                                    "volume": volume,
                                    "expDate":experimentDate,
                                    "product":product
                                };
                            this.g_sampleGroupTable.push(json);
                        }
                    });
                  if(this.templatePick == 'oqo'){
                        this.cover_txt = edt_txt.qo_cover(this.radioPick, this.nowdate, repno, this.productPick);
                        this.g_info_txt =  edt_txt.qo_g_info_group(this.radioPick, this.g_sampleGroupTable, requester, consignee, repno, deliverydate, sampt, experimentDate);
                        this.sampleQCTableData_txt = edt_txt.sampleQCTableData(this.checkedColumnData);
                        this.sampleQCResult_txt = edt_txt.kolon_sampleQCResult(this.sampleQCTableHeader_txt, this.sampleQCTableData_txt, 'Nanodrop2000, Qubit 3.0')
                        //await this.getImgFile() => 젤 샘플 무제한 생성 주석처리
                        this.dna_quality_txt = edt_txt.kolon_dna_quality(this.imgData, this.lastImgData, this.g_sampleTable)
                        this.content = this.cover_txt + this.g_info_txt + this.sampleQCResult_txt + this.dna_quality_txt;
                    }else if(this.templatePick == 'oqx'){
                        this.cover_txt = edt_txt.qo_cover(this.radioPick, this.nowdate, repno, this.productPick);
                        this.g_info_txt = edt_txt.qo_g_info_group(this.radioPick, this.g_sampleGroupTable, requester, consignee, repno, deliverydate, sampt, experimentDate);
                        this.sampleQCTableData_txt = edt_txt.sampleQCTableData(this.checkedColumnData);
                        this.sampleQCResult_txt = edt_txt.kolon_sampleQCResult(this.sampleQCTableHeader_txt, this.sampleQCTableData_txt, 'Nanodrop2000')
                        //await this.getImgFile()=> 젤 샘플 무제한 생성 주석처리
                        this.dna_quality_txt = edt_txt.kolon_dna_quality(this.imgData, this.lastImgData, this.g_sampleTable)
                        this.content = this.cover_txt + this.g_info_txt + this.sampleQCResult_txt + this.dna_quality_txt;
                    }
                } catch (error) {
                    console.log(error)
                }
            },
            async sampleTypeList(){
                try {  
                    this.sampleTypeForm = [];
                    this.sampleSingleType = '-';
                    let sampleheader = common.sampleHeader(this.menuData);
                    let typeCode = sampleheader.find(a=>a.columnAttr == 'sampletype').columnCode;
                    let typeArr = [];
                    let json = '';
                    this.sampleData.forEach( a=>{
                      json = {
                        id : a[typeCode],
                        name : a[typeCode]
                       };    
                        typeArr.push(json);
                    });
                    let setTypeArr = typeArr.filter((item1, idx1)=>{
                        return typeArr.findIndex((item2, idx2)=>{
                            return item1.id == item2.id;
                        }) == idx1;
                    });
                    if(setTypeArr.length == 1)this.sampleSingleType = setTypeArr[0]['id'];
                   
                    this.sampleTypeForm = common.isNull(this.sampleSingleType )?'-':this.sampleSingleType;
                    this.sampleTypeForm = setTypeArr;
                } catch (error) {
                    console.log(error)
                }    
            },
            async selectSampleType(sampt){
                try {
                    /*
                    접수에서 샘플 타입들이 여러개일시에 하나만 일괄 선택 가능 함수 
                    sampt => 사용자가 선택한 샘플타입
                    */


                    this.g_sampleTable = [];
                    let json = '';
                    let sampleName = '';
                    let sampleType = '';
                    let volume = '';
                    let experimentDate = '';
                    let product = '';
                    let sampleheader = common.sampleHeader(this.menuData);
                    let sampleNameCode = sampleheader.find(a=>a.columnAttr == 'samplename').columnCode;
                    let sampletypeCode = sampleheader.find(a=>a.columnAttr == 'sampletype').columnCode;
                    let productCode = sampleheader.find(a=>a.columnAttr == 'product').columnCode;
                    let volumnCode = this.exp_d_h_info.find(a=>a.columnAttr == 'volume').columnCode;
                    
                    let rn = Number(0);
                        this.sampleData.forEach((a, b)=>{
                            this.sample_info.push({'no':Number(rn)+1});
                            experimentDate = this.sample_info[rn].experimentdate = common.isNull(this.nowdate) ? '' : this.nowdate;
                            rn++
                    });
                    let requester='';
                    let consignee='';
                    let repno='';
                    let deliverydate='';
                    requester = this.sampleData[0]['C00408'];//의뢰자
                    consignee = this.sampleData[0]['C00409'];//인수자
                    deliverydate = this.sampleData[0]['C00410'];//입고일
                    repno = this.sampleData[0]['C00411'];//수주번호
                    requester = common.isNull(requester)?'-':requester;
                    consignee = common.isNull(consignee)?'-':consignee;
                    deliverydate = common.isNull(deliverydate)?'-':deliverydate;
                    repno = common.isNull(repno)?'-':repno;
                    sampt = common.isNull(sampt)?'-':sampt;//선택샘플
                  
                    //sample data list
                    this.sampleData.forEach((a,b) => {
                        if(a[sampletypeCode] == sampt){
                            sampleName = common.isNull(a[sampleNameCode])?'-':a[sampleNameCode];
                            sampleType = common.isNull(a[sampletypeCode])?'-':a[sampletypeCode];
                            volume = common.isNull(a[volumnCode])?'-':a[volumnCode];
                            experimentDate = common.isNull(experimentDate)?'-':experimentDate;
                            product = common.isNull(a[productCode])?'-':a[productCode];
                            json = {
                                    "sampleName": sampleName,
                                    "sampleType": sampleType,
                                    "volume": volume,
                                    "expDate":experimentDate,
                                    "product":product
                                };
                            this.g_sampleTable.push(json);
                        }
                    });    
                    
                    if(this.templatePick == 'oqo'){
                        this.cover_txt = edt_txt.qo_cover(this.radioPick, this.nowdate, repno, this.productPick);
                        this.g_info_txt =  edt_txt.qo_g_info(this.radioPick, this.g_sampleTable, requester, consignee, repno, deliverydate, sampt, this.productPick);
                        this.sampleQCTableData_txt = edt_txt.sampleQCTableData(this.checkedColumnData);
                        this.sampleQCResult_txt = edt_txt.kolon_sampleQCResult(this.sampleQCTableHeader_txt, this.sampleQCTableData_txt, 'Nanodrop2000, Qubit 3.0')
                        //await this.getImgFile()
                        this.dna_quality_txt = edt_txt.kolon_dna_quality(this.imgData, this.lastImgData, this.g_sampleTable)
                        this.content = this.cover_txt + this.g_info_txt + this.sampleQCResult_txt + this.dna_quality_txt;
                    }else if(this.templatePick == 'oqx'){
                        this.cover_txt = edt_txt.qo_cover(this.radioPick, this.nowdate, repno, this.productPick);
                        this.g_info_txt = edt_txt.qo_g_info(this.radioPick, this.g_sampleTable, requester, consignee, repno, deliverydate, sampt, this.productPickf);
                        this.sampleQCTableData_txt = edt_txt.sampleQCTableData(this.checkedColumnData);
                        this.sampleQCResult_txt = edt_txt.kolon_sampleQCResult(this.sampleQCTableHeader_txt, this.sampleQCTableData_txt, 'Nanodrop2000')
                        //await this.getImgFile()
                        this.dna_quality_txt = edt_txt.kolon_dna_quality(this.imgData, this.lastImgData, this.g_sampleTable)
                        this.content = this.cover_txt + this.g_info_txt + this.sampleQCResult_txt + this.dna_quality_txt;
                    }
                } catch (error) {
                    console.log(error)
                }
            },
            async makeA4(gbn){
                try{
                    /*

                        전체 탬플릿 레이아웃 생성 함수 

                    */
                    this.g_sampleTable = [];
                    //General Information
                    let requester='';
                    let consignee='';
                    let repno='';
                    let deliverydate='';
                    let totalsampletype='';
                    requester = this.sampleData[0]['C00408'];//의뢰자
                    consignee = this.sampleData[0]['C00409'];//인수자
                    deliverydate = this.sampleData[0]['C00410'];//입고일
                    totalsampletype = this.sampleData[0][sampletypeCode];//샘플종류
                    repno = this.sampleData[0]['C00411'];//수주번호
                    requester = common.isNull(requester)?'-':requester;
                    consignee = common.isNull(consignee)?'-':consignee;
                    deliverydate = common.isNull(deliverydate)?'-':deliverydate;
                    totalsampletype = common.isNull(totalsampletype)?'-':totalsampletype;
                    repno = common.isNull(repno)?'-':repno;
                    //sample, sampleType, Sample volume, Experiment Date, Product
                    let json = '';
                    let sampleId = '';
                    let sampleName = '';
                    let sampleType = '';
                    let volume = '';
                    let experimentDate = '';
                    let product = '';
                    let sampleheader = common.sampleHeader(this.menuData);
                    let sampleNameCode = sampleheader.find(a=>a.columnAttr == 'samplename').columnCode;
                    let sampletypeCode = sampleheader.find(a=>a.columnAttr == 'sampletype').columnCode;
                    let productCode = sampleheader.find(a=>a.columnAttr == 'product').columnCode;
                    let sampleIdCode = sampleheader.find(a=>a.columnAttr == 'sampleid').columnCode;
                    let volumnCode = this.exp_d_h_info.find(a=>a.columnAttr == 'volume').columnCode;
                   
                    let rn = Number(0);
                    this.sampleData.forEach((a, b)=>{
                      this.sample_info.push({'no':Number(rn)+1});
                      experimentDate = this.sample_info[rn].experimentdate = common.isNull(this.nowdate) ? '-' :this.nowdate ;
                      rn++
                    });
                    //experimentDate = experimentDate.substr(0,experimentDate.indexOf('~'))+'<br/>'+experimentDate.substr(experimentDate.indexOf('~'), experimentDate.length);
                    this.imgData.splice(0);
                    this.nanoData.splice(0);
                        this.sampleData.forEach((a,b) => {
                            sampleId = common.isNull(a[sampleIdCode])?'-':a[sampleIdCode];
                            sampleName = common.isNull(a[sampleNameCode])?'-':a[sampleNameCode];
                            sampleType = common.isNull(a[sampletypeCode])?'-':a[sampletypeCode];
                            volume = common.isNull(a[volumnCode])?'-':a[volumnCode];
                            experimentDate = common.isNull(experimentDate)?'-':experimentDate;
                            product = common.isNull(a[productCode])?'-':a[productCode];
                            json = {
                              "sampleName": sampleName,
                              "sampleType": sampleType,
                              "volume": volume,
                              "expDate":experimentDate,
                              "product":product,
                              "sampleId":sampleId
                            };
                            this.g_sampleTable.push(json);
                        });
                    //console.log(this.g_sampleTable)
                     this.sampleSingleType = common.isNull(this.sampleSingleType )?'-':this.sampleSingleType;
                    //칼럼헤더 생성 
                    var rowData = [];
                    this.checkedColumnData.splice(0);
                    this.checkedColumnHeader.splice(0);
                    //console.log("header 찾기")
                    //console.log( this.checkedColumnHeader)
                    this.sampleQCResult.forEach(a=>{this.checkedColumnHeader.push([]);});
                    let purity = [];
                    let rowspan = 1;
                    let deptcode = ''
                    let sd_cnt = Number(0);
                    let barcodeCode = common.sampleHeader(this.menuData).find(c => c.columnAttr == 'samplebarcode').columnCode;
                    let sampleData = [];
                    if(!common.isNull(this.radioPick)){
                        this.sampleData.forEach((a, b)=>{
                            deptcode = common.receptionHeader(this.menuData).find(c => c.columnType == 'COMPANY').columnCode
                            if(this.radioPick == a[deptcode]) sampleData.push(a)
                        });
                    }
                    
                     if(gbn=='oqo'){
                        this.checkedColumn = [];
                        this.checkedColumn = [ "C00038","C00041","C00042","C00039","C00040","C00043","C00044"];
                        this.watchData = 0;

                        //console.log(this.checkedColumn)
                    }else if(gbn=='oqx'){
                        this.checkedColumn = [];
                        this.checkedColumn = [ "C00038","C00041","C00042","C00039","C00040"];
                        this.watchData = 0;
                   
                    }else if(gbn=='nano'){
                        this.checkedColumn =[];
                        this.checkedColumn = [ "C00094","C00039","C00040","C00095","C00041","C00042"];
                    }
                    console.log(this.exp_d_h_info)
                    this.checkedColumn.forEach((a, d)=>{
                        this.exp_d_h_info.forEach((b, c)=>{
                            if(a === b.columnCode) {
                                this.checkedColumnHeader[Number(b.idx)-1].push(b.columnName);
                                if(b.columnAttr == '260') purity.push(b.columnName);
                            }
                        });
                        sampleData.forEach((b, c)=>{
                            if(this.sampleNamePick == 'barcode'){
                                rowData.push(Number(c)+1, b[barcodeCode])
                            }else if(this.sampleNamePick == 'sampleName'){
                                rowData.push(Number(c)+1, b[sampleNameCode])
                            }
                            else rowData.push(Number(c)+1, b.sampleNo);
                            if(this.checkedColumnData.length >= sampleData.length){
                                this.checkedColumnData[c].push(common.isNull(b[a])?'':b[a]);
                            }else{
                                rowData.push(common.isNull(b[a])?'':b[a]);
                                this.checkedColumnData.push(rowData);
                                rowData = [];
                            }
                        });
                    });
                    this.checkedColumnHeader.forEach((a, b) => {
                        if(a.length === 0)this.checkedColumnHeader[b].push('');
                    });
                    if(this.checkedColumn.length > 0){
                        if(purity.length == 2)rowspan = 3;
                        else rowspan = 2;
                    }
                     
                     if(gbn == 'oqo'){
                        this.cover_txt = edt_txt.qo_cover(this.radioPick, this.nowdate, repno, this.productPick);
                        this.g_info_txt = edt_txt.qo_g_info(this.radioPick, this.g_sampleTable, requester, consignee, repno, deliverydate, this.sampleSingleType, this.productPick);
                        this.sampleQCTableData_txt = edt_txt.sampleQCTableData(this.checkedColumnData);
                        this.sampleQCTableHeader_txt = edt_txt.thrid_sampleQCTableHeader(rowspan, this.firColspan, this.secColspan, this.thrColspan, this.checkedColumnHeader, purity, ''); 
                        this.sampleQCResult_txt = edt_txt.kolon_sampleQCResult(this.sampleQCTableHeader_txt, this.sampleQCTableData_txt, 'Nanodrop2000, Qubit 3.0')
                        await this.getImgFile()
                        this.dna_quality_txt = edt_txt.kolon_dna_quality(this.imgData, this.lastImgData,this.g_sampleTable )
                        this.content = this.cover_txt + this.g_info_txt + this.sampleQCResult_txt + this.dna_quality_txt;
                    }else if(gbn == 'oqx'){
                        //console.log(purity)
                        this.cover_txt = edt_txt.qo_cover(this.radioPick, this.nowdate, repno, this.productPick);
                        this.g_info_txt = edt_txt.qo_g_info(this.radioPick, this.g_sampleTable, requester, consignee, repno, deliverydate, this.sampleSingleType, this.productPick);
                        this.sampleQCTableData_txt = edt_txt.sampleQCTableData(this.checkedColumnData);
                        this.sampleQCTableHeader_txt = edt_txt.thrid_sampleQCTableHeaderQCX(rowspan, this.firColspan, 0, this.thrColspan, this.checkedColumnHeader, purity, ''); 
                        this.sampleQCResult_txt = edt_txt.kolon_sampleQCResult(this.sampleQCTableHeader_txt, this.sampleQCTableData_txt, 'Nanodrop2000')
                        await this.getImgFile()
                        this.dna_quality_txt = edt_txt.kolon_dna_quality(this.imgData, this.lastImgData,this.g_sampleTable  )
                        this.content = this.cover_txt + this.g_info_txt + this.sampleQCResult_txt + this.dna_quality_txt;
                    }else if(gbn == 'nano'){
                        this.checkedColumnHeader = [["Input DNA(ng)","A260/280", "A260/230","Conc. (ng/ul)","Volume(ul)","Total DNA(ug)" ]]
                        this.cover_txt = edt_txt.qo_cover(this.radioPick, this.nowdate, repno, this.productPick);
                        this.g_info_txt = edt_txt.qo_g_info(this.radioPick, this.g_sampleTable, requester, consignee, repno, deliverydate, this.sampleSingleType, this.productPick);
                        this.sampleQCTableData_txt = edt_txt.sampleQCTableData(this.checkedColumnData);
                        this.sampleQCTableHeader_txt = edt_txt.thrid_sampleQCTableHeaderNano(rowspan, 3, 3, this.thrColspan, this.checkedColumnHeader, ["A260/280", "A260/230"], ''); 
                        this.sampleQCResult_txt = edt_txt.kolon_sampleQCResultNano(this.sampleQCTableHeader_txt, this.sampleQCTableData_txt, ' Qubit 3.0')
                        await this.getImgFile()
                         this.dna_quality_txt = edt_txt.kolon_dna_quality(this.imgData, this.lastImgData,this.g_sampleTable  )
                        this.content = this.cover_txt + this.g_info_txt + this.sampleQCResult_txt + this.dna_quality_txt;
                    }
                }catch (error) {console.log(error)}
            },
            async finalFunction(sampleNamePickR){
                try{
                    //sampleNamePickR => 사용자가 선택한 샘플테이블에 표시할 NAME 방식 ex)barcode, samplename, sample id
                    sampleNamePickR = common.isNull(this.sampleNamePick)?sampleNamePickR:this.sampleNamePick;
                    this.g_sampleTable = [];
                    let requester='';
                    let consignee='';
                    let repno='';
                    let deliverydate='';
                    let totalsampletype='';
                    requester = this.sampleData[0]['C00408'];//의뢰자
                    consignee = this.sampleData[0]['C00409'];//인수자
                    deliverydate = this.sampleData[0]['C00410'];//입고일
                    totalsampletype = this.sampleData[0][sampletypeCode];//샘플종류
                    repno = this.sampleData[0]['C00411'];//수주번호
                    requester = common.isNull(requester)?'-':requester;
                    consignee = common.isNull(consignee)?'-':consignee;
                    deliverydate = common.isNull(deliverydate)?'-':deliverydate;
                    totalsampletype = common.isNull(totalsampletype)?'-':totalsampletype;
                    repno = common.isNull(repno)?'-':repno;
                    //sample, sampleType, Sample volume, Experiment Date, Product
                    let json = '';
                    let sampleId = '';
                    let sampleName = '';
                    let sampleType = '';
                    let volume = '';
                    let experimentDate = '';
                    let product = '';
                    let sampleheader = common.sampleHeader(this.menuData);
                    let sampleNameCode = sampleheader.find(a=>a.columnAttr == 'samplename').columnCode;
                    let sampletypeCode = sampleheader.find(a=>a.columnAttr == 'sampletype').columnCode;
                    let productCode = sampleheader.find(a=>a.columnAttr == 'product').columnCode;
                    let sampleIdCode = sampleheader.find(a=>a.columnAttr == 'sampleid').columnCode;
                    let volumnCode = this.exp_d_h_info.find(a=>a.columnAttr == 'volume').columnCode;
                   
                    let rn = Number(0);
                    this.sampleData.forEach((a, b)=>{
                      this.sample_info.push({'no':Number(rn)+1});
                      experimentDate = this.sample_info[rn].experimentdate = common.isNull(this.nowdate) ? '-' :this.nowdate ;
                      rn++
                    });
                   
                    this.imgData.splice(0);
                    this.nanoData.splice(0);
                        this.sampleData.forEach((a,b) => {
                            sampleId = common.isNull(a[sampleIdCode])?'-':a[sampleIdCode];
                            sampleName = common.isNull(a[sampleNameCode])?'-':a[sampleNameCode];
                            sampleType = common.isNull(a[sampletypeCode])?'-':a[sampletypeCode];
                            volume = common.isNull(a[volumnCode])?'-':a[volumnCode];
                            experimentDate = common.isNull(experimentDate)?'-':experimentDate;
                            product = common.isNull(a[productCode])?'-':a[productCode];
                            json = {
                              "sampleName": sampleName,
                              "sampleType": sampleType,
                              "volume": volume,
                              "expDate":experimentDate,
                              "product":product,
                              "sampleId":sampleId
                            };
                            this.g_sampleTable.push(json);
                        });
                    
                     this.sampleSingleType = common.isNull(this.sampleSingleType )?'-':this.sampleSingleType;
                    //칼럼헤더 생성 
                    var rowData = [];
                    this.checkedColumnData.splice(0);
                    this.checkedColumnHeader.splice(0);
                    this.sampleQCResult.forEach(a=>{this.checkedColumnHeader.push([]);});
                    let purity = [];
                    let rowspan = 1;
                    let deptcode = ''
                    let sd_cnt = Number(0);
                    let barcodeCode = common.sampleHeader(this.menuData).find(c => c.columnAttr == 'samplebarcode').columnCode;
                    let sampleData = [];
                    if(!common.isNull(this.radioPick)){
                        this.sampleData.forEach((a, b)=>{
                            deptcode = common.receptionHeader(this.menuData).find(c => c.columnType == 'COMPANY').columnCode
                            if(this.radioPick == a[deptcode]) sampleData.push(a)
                        });
                    }
                    this.checkedColumn.forEach((a, d)=>{
                        this.exp_d_h_info.forEach((b, c)=>{
                            if(a === b.columnCode) {
                                this.checkedColumnHeader[Number(b.idx)-1].push(b.columnName);
                                if(b.columnAttr == '260') purity.push(b.columnName);
                            }
                        });
                        sampleData.forEach((b, c)=>{
                            if(sampleNamePickR == 'barcode'){
                                rowData.push(Number(c)+1, b[barcodeCode])
                            }else if(sampleNamePickR == 'sampleName'){
                                rowData.push(Number(c)+1, b[sampleNameCode])
                            }
                            else rowData.push(Number(c)+1, b.sampleNo);
                            if(this.checkedColumnData.length >= sampleData.length){
                                this.checkedColumnData[c].push(common.isNull(b[a])?'':b[a]);
                            }else{
                                rowData.push(common.isNull(b[a])?'':b[a]);
                                this.checkedColumnData.push(rowData);
                                rowData = [];
                            }
                        });
                    });
                    this.checkedColumnHeader.forEach((a, b) => {
                        if(a.length === 0)this.checkedColumnHeader[b].push('');
                    });
                    if(this.checkedColumn.length > 0){
                        if(purity.length == 2)rowspan = 3;
                        else rowspan = 2;
                    }
                     
                     if(this.templatePick == 'oqo'){
                        this.cover_txt = edt_txt.qo_cover(this.radioPick, this.nowdate, repno, this.productPick);
                        if(this.sampleState == 'group'){//사용자 group선택후 sample name 변경시 초기화 방지
                            this.g_info_txt =  edt_txt.qo_g_info_group(this.radioPick, this.g_sampleGroupTable, requester, consignee, repno, deliverydate, this.sampleGroupPick, experimentDate);
                        }else{
                            this.g_info_txt = edt_txt.qo_g_info(this.radioPick, this.g_sampleTable, requester, consignee, repno, deliverydate, this.sampleSingleType,  this.productPick);
                        }
                        this.sampleQCTableData_txt = edt_txt.sampleQCTableData(this.checkedColumnData);
                        this.sampleQCTableHeader_txt = edt_txt.thrid_sampleQCTableHeader(rowspan, this.firColspan, this.secColspan, this.thrColspan, this.checkedColumnHeader, purity, ''); 
                        this.sampleQCResult_txt = edt_txt.kolon_sampleQCResult(this.sampleQCTableHeader_txt, this.sampleQCTableData_txt, 'Nanodrop2000, Qubit 3.0')
                        await this.getImgFile()
                        this.dna_quality_txt = edt_txt.kolon_dna_quality(this.imgData, this.lastImgData,this.g_sampleTable )
                        this.content = this.cover_txt + this.g_info_txt + this.sampleQCResult_txt + this.dna_quality_txt;
                    }else if(this.templatePick == 'oqx'){
                        this.cover_txt = edt_txt.qo_cover(this.radioPick, this.nowdate, repno, this.productPick);
                         if(this.sampleState == 'group'){//사용자 group선택후 sample name 변경시 초기화 방지
                            this.g_info_txt =  edt_txt.qo_g_info_group(this.radioPick, this.g_sampleGroupTable, requester, consignee, repno, deliverydate, this.sampleGroupPick, experimentDate);
                        }else{
                            this.g_info_txt = edt_txt.qo_g_info(this.radioPick, this.g_sampleTable, requester, consignee, repno, deliverydate, this.sampleSingleType,  this.productPick);
                        }
                        this.sampleQCTableData_txt = edt_txt.sampleQCTableData(this.checkedColumnData);
                        this.sampleQCTableHeader_txt = edt_txt.thrid_sampleQCTableHeaderQCX(rowspan, this.firColspan, 0, this.thrColspan, this.checkedColumnHeader, purity, ''); 
                        this.sampleQCResult_txt = edt_txt.kolon_sampleQCResult(this.sampleQCTableHeader_txt, this.sampleQCTableData_txt, 'Nanodrop2000')
                        await this.getImgFile()
                        this.dna_quality_txt = edt_txt.kolon_dna_quality(this.imgData, this.lastImgData,this.g_sampleTable  )
                        this.content = this.cover_txt + this.g_info_txt + this.sampleQCResult_txt + this.dna_quality_txt;
                    }else if(this.templatePick == 'nano'){
                        this.checkedColumnHeader = [["Input DNA(ng)","A260/280", "A260/230","Conx. (ng/ul)","Volume(ul)","Total DNA(ug)" ]]
                        this.cover_txt = edt_txt.qo_cover(this.radioPick, this.nowdate, repno, this.productPick);
                         if(this.sampleState == 'group'){
                            this.g_info_txt =  edt_txt.qo_g_info_group(this.radioPick, this.g_sampleGroupTable, requester, consignee, repno, deliverydate, sampt, experimentDate);
                        }else{
                            this.g_info_txt = edt_txt.qo_g_info(this.radioPick, this.g_sampleTable, requester, consignee, repno, deliverydate, this.sampleSingleType,  this.productPick);
                        }
                        this.sampleQCTableData_txt = edt_txt.sampleQCTableData(this.checkedColumnData);
                        this.sampleQCTableHeader_txt = edt_txt.thrid_sampleQCTableHeaderNano(rowspan, 3, 3, this.thrColspan, this.checkedColumnHeader, ["A260/280", "A260/230"], ''); 
                        this.sampleQCResult_txt = edt_txt.kolon_sampleQCResultNano(this.sampleQCTableHeader_txt, this.sampleQCTableData_txt, ' Qubit 3.0')
                        await this.getImgFile()
                         this.dna_quality_txt = edt_txt.kolon_dna_quality(this.imgData, this.lastImgData,this.g_sampleTable  )
                        this.content = this.cover_txt + this.g_info_txt + this.sampleQCResult_txt + this.dna_quality_txt;
                    }
                    } catch (error) {
                    
                }
            },
         
			/*
			* gel image file select
			*/
			async getImgFile() {
                try{
                    //img 가져오기
                    var params = [];
                    let uid = [];
                    let preid = [];
                    params = {'uid' : this.uid};
                    let headerid = [];
                    let lastheaderid = [];
                    var request = {params : params}
                    await this.$axios.get(this.$apiHost +'/experiments/getimage', request)
                    .then(res=>{
                        for (let i in res.data) {
                            if (res.data[i].classification === 'gel') {
                                this.imgData.push(res.data[i]);
                            } else {
                                this.nanoData.push(res.data[i]);
                            }
                        }
                    }).catch(err=>{console.log(err)});
                }catch (error) {console.log(error)}
            },
            imgFileHandler(files) {
                let tForm = new FormData();
                for (let i in files) {
                    tForm.append('file', files[i])
                }
                let formData = new FormData();
                for (let pair of tForm.entries()) {
                    formData.append(pair[0], pair[1]);
                }
                this.imgFileFormData = formData;
                let reader = new FileReader();
                var imgtag = document.getElementById("bioanalyzer");
                reader.onloadend = function () {
                    //console.log(imgtag.src)
                    imgtag.src = reader.result;
                }
                reader.readAsDataURL(files[0]);
            },
            imgFileHandler2(files) {
                let tForm = new FormData();
                for (let i in files) {
                    tForm.append('file', files[i])
                }
                let formData = new FormData();
                for (let pair of tForm.entries()) {
                    formData.append(pair[0], pair[1]);
                }
                this.imgFileFormData = formData;
                let reader = new FileReader();
                var imgtag = document.getElementById("hab_dynebio");
                reader.onloadend = function () {
                    imgtag.src = reader.result;
                    //console.log(imgtag)
                }
                reader.readAsDataURL(files[0]);
            },
            imgFileHandler3(files) {
                let tForm = new FormData();
                for (let i in files) {
                    tForm.append('file', files[i]);
                }
                let formData = new FormData();
                for (let pair of tForm.entries()) {
                    formData.append(pair[0], pair[1]);
                }
                this.imgFileFormData = formData;
                files.forEach((a,b)=>{
                    let reader = new FileReader();
                    var pimgtag = document.getElementById("p_hab_purification"+b);
                    var imgtag = document.getElementById("hab_purification"+b);
                    reader.onloadend = function () {
                        imgtag.src = reader.result;
                    }
                    reader.readAsDataURL(a);
                    pimgtag.style.display = "block";
                });
            },
            imgFileHandler4(files) {
                let tForm = new FormData();
                for (let i in files) {
                    tForm.append('file', files[i]);
                }
                let formData = new FormData();
                for (let pair of tForm.entries()) {
                    formData.append(pair[0], pair[1]);
                }
                this.imgFileFormData = formData;
                files.forEach((a,b)=>{
                    let reader = new FileReader();
                    var pimgtag = document.getElementById("p_dft"+b);
                    var imgtag = document.getElementById("dft"+b);
                    reader.onloadend = function () {
                        imgtag.src = reader.result;
                    }
                    reader.readAsDataURL(a);
                    pimgtag.style.display = "block";
                });
            },
           
        },
        computed:{
        },
        // watch: {
        //     checkedColumn: function() {
        //         try{
                   
        //             var rowData = [];
        //             this.checkedColumnData.splice(0);
        //             this.checkedColumnHeader.splice(0);
        //             console.log("header 찾기")
        //             console.log( this.checkedColumnHeader)
        //             this.sampleQCResult.forEach(a=>{this.checkedColumnHeader.push([]);});
        //             let purity = [];
        //             let rowspan = 1;
        //             let deptcode = ''
        //             let sd_cnt = Number(0);
        //             let barcodeCode = common.sampleHeader(this.menuData).find(c => c.columnAttr == 'samplebarcode').columnCode;
        //             let sampleData = [];
        //             if(!common.isNull(this.radioPick)){
        //                 this.sampleData.forEach((a, b)=>{
        //                     deptcode = common.receptionHeader(this.menuData).find(c => c.columnType == 'COMPANY').columnCode
        //                     if(this.radioPick == a[deptcode]) sampleData.push(a)
        //                 });
        //             }
                   
        //             this.checkedColumn.forEach((a, d)=>{
        //                 this.exp_d_h_info.forEach((b, c)=>{
        //                     if(a === b.columnCode) {
        //                         this.checkedColumnHeader[Number(b.idx)-1].push(b.columnName);
        //                         if(b.columnAttr == '260') purity.push(b.columnName);
        //                     }
        //                 });
        //                 sampleData.forEach((b, c)=>{
        //                     if(this.sampleNamePick == 'barcode') rowData.push(Number(c)+1, b[barcodeCode]);
        //                     else rowData.push(Number(c)+1, b.sampleNo);
        //                     if(this.checkedColumnData.length >= sampleData.length){
        //                         this.checkedColumnData[c].push(common.isNull(b[a])?'':b[a]);
        //                         //console.log(b[a])
        //                     }else{
        //                         rowData.push(common.isNull(b[a])?'':b[a]);
        //                         this.checkedColumnData.push(rowData);
        //                         rowData = [];
        //                     }
        //                 });
        //             });
        //             console.log("데이터 완성45----------------------------------------------")
        //             this.checkedColumnHeader.forEach((a, b) => {
        //                 if(a.length === 0)this.checkedColumnHeader[b].push('');
        //             });
        //             if(this.checkedColumn.length > 0){
        //                 if(purity.length == 2)rowspan = 3;
        //                 else rowspan = 2;
        //             }
                          
        //             //this.sampleQCResult_txt ="";
                        
        //             if(this.templatePick == 'oqo'){
                        
        //                 this.sampleQCTableData_txt = edt_txt.sampleQCTableData(this.checkedColumnData);
        //                 this.sampleQCTableHeader_txt = edt_txt.thrid_sampleQCTableHeader(rowspan, this.firColspan, this.secColspan, this.thrColspan, this.checkedColumnHeader, purity, ''); 
                       
        //             }else if(this.templatePick == 'oqx'){
                      
        //                 this.sampleQCTableData_txt = edt_txt.sampleQCTableData(this.checkedColumnData);
        //                 this.sampleQCTableHeader_txt = edt_txt.thrid_sampleQCTableHeaderQCX(rowspan, this.firColspan, 0, this.thrColspan, this.checkedColumnHeader, purity, ''); 
                        
                
        //             }
        //             this.finalFunction(this.templatePick);
        //         }catch (error) {console.log(error)}
        //     },
        // }
    }
</script>


// WEBPACK FOOTER //
// src/views/Common/Editor.vue